module.exports = __webpack_public_path__ + "static/media/b2b.ac37119a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/b2b.svg
 ** module id = 1261
 ** module chunks = 0
 **/